import {Component, OnDestroy, OnInit} from '@angular/core';
import {GenericDatatableComponent} from '../../../shared/components/generic-datatable/generic-datatable.component';
import {select} from '@ngrx/store';
import * as fromSites from '../../reducers';
import {SetPreferencesAction} from '../../../shared/actions/preferences';
import * as fromRoot from '../../../shared/reducers';
import {
  ChangeProjectsPageSizeAction,
  ClearProjectsAction,
  LoadProjectsAction, OrderProjectsByAction, PageProjectsToAction,
  QuickSearchProjectsAction, RemoveProjectsAction,
  SearchProjectsAction,
  ToggleSearchProjectsAction
} from '../../actions/projects-list';
import {InvoicesTriggerModalComponent} from '../../../invoices/components/invoices-trigger-modal/invoices-trigger-modal.component';
import {LoadSubAnomalyListAction, SelectOneItemSubListAction} from '../../../shared/actions/subscription-list';
import {ModalEditSfProjectComponent} from '../../../shared/components/modal-edit-sf-project/modal-edit-sf-project.component';
import {filter} from 'rxjs/operators';
import * as _ from 'lodash';
import {ProjectEditSuccessAction} from '../../../shared/actions/project-creation';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ModalComponent} from '@storever/modal-confirmation';
import {combineLatest} from 'rxjs';
import {RemoveOrderPlayerAction} from '../../../order/actions/order-remove-player';

@Component({
  selector: 'storever-player-list',
  templateUrl: '../../../shared/components/generic-datatable/generic-datatable.component.html',
  styleUrls: ['../../../shared/components/generic-datatable/generic-datatable.component.scss']
})
export class ProjectListComponent extends GenericDatatableComponent implements OnInit, OnDestroy {
  bsModalRef: BsModalRef;
  private currentClient$ = this.storeRoot.pipe(select(fromRoot.selectors.getCurrentClient), filter(client => !_.isEmpty(client)));
  ngOnInit(): void {
    super.ngOnInit();
    this.loadDataOnChangeUrl('name descending', 'Projects_row_size');


  }

  ngOnDestroy(): void {
    this.storeRoot.dispatch(new ClearProjectsAction());
    this.dataConfig.form.markAsPristine();
    this.router.navigate( [], { queryParams: {}});
  }

  loadData(): void {
    this.storeRoot.dispatch(new LoadProjectsAction());
  }

  storeSelect(): void {
    this.pageSize$ = this.storeRoot.pipe(select(fromRoot.selectors.getPreferencesByName, 'Projects_row_size'));
    this.count$ = this.storeSite.pipe(select(fromSites.selectors.getProjectsCount));
    this.showFilter$ = this.storeSite.pipe(select(fromSites.selectors.getProjectsShowFilter));
    this.data$ = this.storeSite.pipe(select(fromSites.selectors.getProjects));
    let pageSizeInit = true ;
    this.sub$ = this.pageSize$.subscribe(pageSize => {
      if ( pageSizeInit && pageSize ) {
        this.storeSite.dispatch(new ChangeProjectsPageSizeAction(pageSize));
        pageSizeInit = false;
      }
    });
    this.subscriptions.push(this.sub$);
  }

  orderByChanged(orderBy: string): void {
    this.storeSite.dispatch(new OrderProjectsByAction(orderBy));
  }

  pageSizeChanged(pageSize: number): void {
    this.storeSite.dispatch(new SetPreferencesAction({ name: 'Projects_row_size', value: '' + pageSize }));
    this.storeSite.dispatch(new ChangeProjectsPageSizeAction(pageSize));
  }

  pageChanged(page: number): void {
    this.storeShipping.dispatch(new PageProjectsToAction(page));
  }


  // tslint:disable-next-line:no-any
  applyFilter(filterForm: any): void {
    this.storeSite.dispatch(new SearchProjectsAction(this.filterDeleteIfNilService.flatten(filterForm)));
  }

  applyQuickFilter(query: string): void {
    this.storeSite.dispatch(new QuickSearchProjectsAction(query));
  }

  toggleFilter(showFilter: boolean): void {
    this.storeSite.dispatch(new ToggleSearchProjectsAction(!showFilter));
  }

  disablePagination(): boolean {
    return false;
  }
  showModal($event: MouseEvent, modal: any, data: any): void {// tslint:disable-line:no-any
    if (modal === 'RemoveProject') {
      const initialState = {
        title: 'CONFIRMATION',
        message: 'Are you sure you want to delete this project?',
        deleteBtn: true,
      };
      this.bsModalRef = this.modalService.show(ModalComponent, {initialState});
      this.sub$ = combineLatest(this.modalService.onHide).subscribe(() => {
        if (this.bsModalRef.content.isConfirmed) {
          this.storeSite.dispatch(new RemoveProjectsAction(data.id));
        }

      });
      this.subscriptions.push(this.sub$);
    }
    if (modal === 'EditProject') {
      this.currentClient$.subscribe((client) => {
        if (client) {
          this.storeRoot.dispatch(new SelectOneItemSubListAction({...client, 'clientProjectID' : data.id }));
          this.bsModalRef = this.modalService.show(ModalEditSfProjectComponent);
        }
      });
    }
  }

  // tslint:disable-next-line:no-any
  actionButton(type: string, data?: any): void {
    this.currentClient$.subscribe((client) => {
      if (client) {
        this.storeRoot.dispatch(new SelectOneItemSubListAction(client));
        this.bsModalRef = this.modalService.show(ModalEditSfProjectComponent);
      }
    });
  }
}
